export interface SseMessage {
    event: string
    data: string
    id?: string
}

export interface SseParser {
    /** 디코딩된 텍스트 조각을 넣는다. 청크 경계가 줄 중간이어도 된다 */
    feed: (chunk: string) => void
}

/**
 * Server-Sent Events 프레임 파서.
 *
 * `EventSource` 는 요청 헤더를 못 보내서 Bearer 토큰 방식에는 쓸 수 없다.
 * fetch 스트림으로 읽은 텍스트를 W3C 규칙대로 이벤트로 나눈다. 주석 줄(`: ...`)은 버린다.
 */
export const createSseParser = (onMessage: (message: SseMessage) => void): SseParser => {
    let buffer = ''
    let atStart = true
    let eventName = ''
    let dataLines: string[] = []
    let lastId: string | undefined

    const dispatch = () => {
        if (dataLines.length > 0) {
            onMessage({ event: eventName || 'message', data: dataLines.join('\n'), id: lastId })
        }
        eventName = ''
        dataLines = []
    }

    const processLine = (line: string) => {
        if (line === '') {
            dispatch()
            return
        }
        if (line.startsWith(':')) return

        const separator = line.indexOf(':')
        const field = separator === -1 ? line : line.slice(0, separator)
        let value = separator === -1 ? '' : line.slice(separator + 1)
        if (value.startsWith(' ')) value = value.slice(1)

        if (field === 'event') eventName = value
        else if (field === 'data') dataLines.push(value)
        else if (field === 'id') lastId = value
    }

    return {
        feed: (chunk) => {
            buffer += chunk
            if (atStart && buffer.length > 0) {
                atStart = false
                if (buffer.charCodeAt(0) === 0xfeff) buffer = buffer.slice(1)
            }

            let lineStart = 0
            for (let index = 0; index < buffer.length; index += 1) {
                const char = buffer[index]
                if (char !== '\n' && char !== '\r') continue
                // 마지막 문자가 \r 이면 다음 조각이 \n 일 수 있어 줄을 확정하지 않는다
                if (char === '\r' && index === buffer.length - 1) break

                processLine(buffer.slice(lineStart, index))
                if (char === '\r' && buffer[index + 1] === '\n') index += 1
                lineStart = index + 1
            }
            buffer = buffer.slice(lineStart)
        }
    }
}
